import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { getChartPerbandinganLevel } from '../../services/report-gamification';
import { useQuery } from '@tanstack/react-query';
import DoughnutChart from '../../components/elements/DoughnutChart';
import Card from '../../components/elements/Card';

export default function ChartPerbandinganLevel() {
  const [dataChart, setDataChart] = useState([]);

  const fetchedDataPerbandinganLevel = useQuery({
    queryKey: [`chartLevelComparison`],
    queryFn: () => getChartPerbandinganLevel(),
    enabled: true
  });

  const {
    data: dataLevelComparison,
    isLoading,
    isError
  } = fetchedDataPerbandinganLevel;

  useEffect(() => {
    if (dataChart.length === 0 && dataLevelComparison?.data?.data) {
      const _modifiedData = dataLevelComparison?.data?.data.map((item) => {
        return { ...item, label: item.level };
      });
      setDataChart(_modifiedData);
    }
  }, [dataLevelComparison, dataChart]);

  const renderContent = () => {
    return (
      <DoughnutChart
        chartKeys={['total']}
        chartLabels={dataChart?.map((item) => item.level) || []}
        chartColors={[
          '#F2C94C',
          '#2A62EA',
          '#27AE60',
          '#7B2183',
          '#75B843',
          '#FFC107',
          '#E91E63',
          '#2196F3',
          '#FF5722',
          '#4CAF50',
          '#9C27B0',
          '#FF9800',
          '#3F51B5'
        ]}
        data={dataChart || []}
        loading={isLoading}
        isError={isError}
        onLoad={() => fetchedDataPerbandinganLevel.refetch()}
        showPercentage
        chartLabelPosition="bottom"
        chartHeight={150}
        chartWidth={150}
      />
    );
  };

  return (
    <Card>
      <Stack gap={'xs'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Summary Level</Text>
          <Text className="text-xs-medium" c="gray">
            last 6 month
          </Text>
        </Group>
        {isLoading && <Skeleton height={150} />}
        {!isLoading && renderContent()}
      </Stack>
    </Card>
  );
}
